// ✅ Detect if current template is "ir-sauna"
var isIrSauna = document.querySelector(
  '.suffix-ir-sauna-square, .suffix-new-ultimate-chiller, .suffix-premium-chiller-square, .suffix-default-square, .suffix-barrel-and-barrel-bundles-square'
)

// ✅ Initialize productImagesSwiper based on template
var productImagesSwiper = new Swiper('.swiper-media-list', {
  slidesPerView: 4,
  spaceBetween: 12,
  speed: 600,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
    dynamicBullets: false,
    dynamicMainBullets: 6,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // ✅ Enable mousewheel & touchpad scrolling
  mousewheel: {
    forceToAxis: true, // scrolls only along one axis (vertical/horizontal)
    releaseOnEdges: true, // allows normal page scroll when at edges
    sensitivity: 1, // adjust scroll speed (higher = faster)
  },

  // ✅ Allow touch gestures for laptops/touch devices
  simulateTouch: true,
  touchRatio: 1,
  touchAngle: 45,
  grabCursor: true,

  // ✅ Breakpoints for responsive behavior
  breakpoints: isIrSauna
    ? {
        // For IR Sauna template
        1300: {
          direction: 'vertical',
          slidesPerView: 5.4,
          spaceBetween: 15,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        1024: {
          direction: 'vertical',
          slidesPerView: 4,
          spaceBetween: 12,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        900: {
          direction: 'vertical',
          slidesPerView: 3.7,
          spaceBetween: 12,
          centeredSlides: false,
          centeredSlidesBounds: false,
        },
        700: {
          direction: 'horizontal',
          slidesPerView: 4,
          spaceBetween: 10,
          centeredSlides: false,
          centeredSlidesBounds: false,
          dynamicBullets: true,
          dynamicMainBullets: 8,
        },
        520: {
          direction: 'horizontal',
          slidesPerView: 3.5,
          spaceBetween: 10,
          centeredSlides: false,
          centeredSlidesBounds: false,
          dynamicBullets: true,
          dynamicMainBullets: 8,
        },

        0: {
          direction: 'horizontal',
          slidesPerView: 3,
          spaceBetween: 10,
          centeredSlides: false,
          centeredSlidesBounds: false,
          dynamicBullets: true,
          dynamicMainBullets: 8,
        },
      }
    : {
        // For all other templates
        1201: {
          slidesPerView: 4,
        },
        993: {
          slidesPerView: 2.7,
        },
        900: {
          slidesPerView: 3.7,
        },
        700: {
          slidesPerView: 4,
        },
        520: {
          slidesPerView: 3.5,
        },
        320: {
          slidesPerView: 3,
        },
      },
})

// ✅ Function to hide next/prev arrows at start or end (for sauna only)
function toggleSwiperArrows(swiper) {
  const nextBtn = swiper.navigation.nextEl
  const prevBtn = swiper.navigation.prevEl
  if (!nextBtn || !prevBtn) return

  if (swiper.isBeginning) {
    prevBtn.classList.add('swiper-button-disabled')
  } else {
    prevBtn.classList.remove('swiper-button-disabled')
  }

  if (swiper.isEnd) {
    nextBtn.classList.add('swiper-button-disabled')
  } else {
    nextBtn.classList.remove('swiper-button-disabled')
  }
}

// ✅ Run arrow toggle only for sauna
if (isIrSauna) {
  productImagesSwiper.on('init', function () {
    toggleSwiperArrows(productImagesSwiper)
  })
  productImagesSwiper.on('slideChange', function () {
    toggleSwiperArrows(productImagesSwiper)
  })
}

// ✅ Main Swiper for product images
var productMainImagesSwiper = new Swiper('.main-product-swiper', {
  slidesPerView: 1,
  speed: 600,
  spaceBetween: 20,
})

// ✅ Sync both swipers
productImagesSwiper.on('slideChange', function () {
  productMainImagesSwiper.slideTo(productImagesSwiper.activeIndex)
})
productMainImagesSwiper.on('slideChange', function () {
  productImagesSwiper.slideTo(productMainImagesSwiper.activeIndex)
})

// ✅ Image and Variant handling
const productImagesSwiperSliders = productImagesSwiper.slides
const productImages = document.querySelectorAll(
    '.subimages-product .sub-image'
  ),
  mainImages = document.querySelectorAll('.custom-product__media-item'),
  productVariants = document.querySelectorAll('.c-option-item'),
  productCurrentTexts = document.querySelectorAll('.current-value-variant'),
  productVariantWrapper = document.querySelectorAll('.js.product-form__input'),
  cartTriggerSectionButton = document.querySelector('.cartAddJsTrigger'),
  scrollWidgetButton = document.querySelector(
    '.scrollingWidget__actions .product-form-button-c'
  ),
  productFormTexts = document.querySelectorAll('.form-text-js')

function setMainImage(index) {
  mainImages.forEach((image) => {
    image.dataset.index != index
      ? image.classList.remove('is-active')
      : image.classList.add('is-active')
  })
}

productImages.forEach((image) => {
  image.addEventListener('click', () => {
    productImages.forEach((img) => img.classList.remove('is-active'))
    image.classList.add('is-active')
    setMainImage(image.dataset.index)
  })
})

productVariants.forEach((option) => {
  option.addEventListener('click', () => {
    productCurrentTexts.forEach((text) => {
      if (text.dataset.name == option.dataset.name) {
        text.innerText = option.dataset.value
      }
    })

    setTimeout(function () {
      document.querySelectorAll('.prod-variants span').forEach((item) => {
        if (
          item.dataset.variantId == window.location.href.split('?variant=')[1]
        ) {
          productImagesSwiperSliders.forEach((slide) => {
            if (slide.dataset.imgId == item.dataset.img) slide.click()
          })
        }
      })

      const locationString = window.location.search
      if (locationString.includes('?variant=')) {
        const variantId = locationString.replace('?variant=', '')
        productFormTexts.forEach((text) => {
          text.dataset.id == variantId
            ? text.classList.add('is-active')
            : text.classList.remove('is-active')
        })
      }
    }, 0)
  })
})

if (localStorage.getItem('selected-variant') == 'false') {
  productVariantWrapper.forEach((variant) => {
    const firstVariant = variant.querySelector('.c-option-item')
    if (firstVariant) firstVariant.click()
  })
}

$(document).on('cart.requestComplete', function (event, cart) {
  console.log('was added')
})

if (cartTriggerSectionButton) {
  cartTriggerSectionButton.addEventListener('click', () => {
    setTimeout(() => {
      scrollWidgetButton.click()
    }, 300)
  })
}

// ✅ Logic for Swiper slides activation
function setActiveSlidersHandler(index) {
  productImagesSwiperSliders.forEach((slide) => {
    slide.dataset.index != index
      ? slide.classList.remove('swiper-slide-active')
      : slide.classList.add('swiper-slide-active')
  })
}

productImagesSwiperSliders.forEach((slide) => {
  slide.addEventListener('click', () => {
    const slideIndex = slide.dataset.index
    productImagesSwiper.slideTo(slideIndex - 1)
    productMainImagesSwiper.slideTo(slideIndex - 1)
    setActiveSlidersHandler(slideIndex)
    setMainImage(slideIndex)
  })
})

productImagesSwiper.on('slideChange', function () {
  setMainImage(productImagesSwiper.realIndex + 1)
})

// ✅ Variant text highlighting
productFormTexts.forEach((text, index) => {
  const locationString = window.location.search
  if (locationString.includes('?variant=')) {
    const variantId = locationString.replace('?variant=', '')
    text.dataset.id == variantId
      ? text.classList.add('is-active')
      : text.classList.remove('is-active')
  } else {
    index === 0
      ? text.classList.add('is-active')
      : text.classList.remove('is-active')
  }
})

// ✅ Sticky Add-to-Cart Bar
window.addEventListener('scroll', function () {
  var distanceFromTop = $(document).scrollTop()
  if (distanceFromTop >= 200) {
    jQuery('div.atcbar.custom').fadeIn(400).removeClass('hidden')
    jQuery('body').addClass('enable-add-to-sticky')
  } else {
    jQuery('div.atcbar.custom').fadeOut(400).addClass('hidden')
    jQuery('body').removeClass('enable-add-to-sticky')
  }

  if (jQuery('.scrollingWidget--active').length) {
    jQuery('body').addClass('enable-add-to-sticky')
  } else {
    jQuery('body').removeClass('enable-add-to-sticky')
  }
})

$(document).ready(function () {
  var $swiperList = $('.suffix-ir-sauna-square .swiper-media-list')
  var $lastItem = $swiperList.find('.swiper-slide:last')
  var wasVisible = false
  var scrollTimer // 👈 Timer variable

  $swiperList.on('scroll', function () {
    clearTimeout(scrollTimer) // 👈 reset timer every time user scrolls

    var $this = $(this)
    scrollTimer = setTimeout(function () {
      // 👈 run code after delay
      var containerTop = $this.scrollTop()
      var containerBottom = containerTop + $this.outerHeight()

      var itemTop = $lastItem.position().top
      var itemBottom = itemTop + $lastItem.outerHeight()

      // Check if last item is fully visible
      var isVisible = itemBottom <= containerBottom && itemTop >= containerTop

      // Trigger only when visibility changes
      if (isVisible && !wasVisible) {
        $this.addClass('end-scroll')
        wasVisible = true
        console.log('Reached bottom (after delay)')
      } else if (!isVisible && wasVisible) {
        $this.removeClass('end-scroll')
        wasVisible = false
        console.log('Scrolled up (after delay)')
      }
    }, 100) // 👈 delay in milliseconds (e.g., 300ms = 0.3s)
  })
})
